export const trackingEvents = {
  todo_lists: {
    created_list: "Created New To Do List",
    edited_list: "Edited To Do List",
    deleted_list: "Deleted To Do List",
    set_list_visible: "Set To Do List as Visible",
    set_list_hidden: "Set To Do List as Hidden",
    created_todo: "Created New To Do Item",
    edited_todo: "Edited To Do Item",
    deleted_todo: "Deleted To Do Item",
    viewed_todo: "Viewed To Do Item",
    reordered_items: "Reordered To Do Items",
    filtered_by_assigned_user: "Filtered To Do's by Assigned User",
    filtered_by_requester: "Filtered To Do's by Task Requester",
    filtered_by_from_research: "Filtered To Do's from Research",
    filtered_by_not_from_research: "Filtered To Do's not from Research",
    filtered_by_show_completed: "Toggle Show Completed ToDo's",
    sorted_by_name: "Sorted To Do's by Name",
    sorted_by_date: "Sorted To Do's by End Date",
    switched_to_old_todos: "Switched to Old To Do's",
    visited_todos_page: "Visited To Do Lists Page",
    viewed_all_projects: "Viewed All Projects To Do Lists Page",
    visited_rollup: "Visited To Do Lists Rollup Views",
    clicked_help_guide: "Clicked on To Do Lists Help Guide"
  },
  crowdsorce: {
    visited_page: "Visited Crowdsource Ideas Page",
    viewed_idea: "Viewed Crowdsource Idea",
    accepted_as_research: "Accepted Crowdsourced Idea as Research",
    accepted_as_idea: "Accepted Crowdsourced Idea as Idea",
    deleted: "Deleted Crowdsource Idea",
    rejected: "Rejected Crowdsource Idea",
    shared_from_main: "Copied Crowdsource Share Link on Main View",
    shared_from_modal: "Copied Crowdsource Shared Link in Help Modal",
    switched_to_old_view: "Clicked on Switched to Old Crowdsource Ideas",
    visited_rollup: "Visited Crowdsource Ideas Rollup Views",
    clicked_help_guide: "Clicked on Crowdsource Ideas Help Guide",
    visited_external_page: "Visited External Crowdsource Page"
  },
  ee_roadmap: {
    visited_page: "Visited Company Public Roadmap"
  },
  brainstorming_idea: {
    created_idea: "Created New Brainstorming Idea",
    edited_idea: "Edited Brainstorming Idea",
    accepted_as_research: "Accepted Brainstorming Idea as Research",
    accepted_as_idea: "Accepted Brainstorming Idea as Idea",
    rejected: "Rejected Brainstorming Idea"
  }
} as const;
